export default "__VITE_ASSET__d6348600__"